module.exports = __webpack_public_path__ + "static/img/printkupinstall2.f386016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/printkupinstall2.png
// module id = YpVT
// module chunks = 0